//#region IMPORTS
import { Combobox } from "@headlessui/react";
//#endregion

//#region INTERFACE
interface Props {
  disabled?: boolean;
  value: any;
  text: string;
}
//#endregion

export function MainComboboxOption({ text, value, disabled = false }: Props) {
  return (
    <Combobox.Option
      disabled={disabled}
      value={value}
      className="group relative cursor-default rounded-md select-none py-1 pl-3 pr-9 text-gray-900 data-[focus]:bg-gray-200 data-[focus]:text-gray-900 hover:cursor-pointer"
    >
      <span className="block truncate group-data-[selected]:font-semibold">
        {text}
      </span>
    </Combobox.Option>
  );
}
